import { Linking, Platform } from 'react-native';

/**
 * Navigate to an external URL, leaving the onboarding app in the SAME tab.
 *
 * On web, uses `window.location.assign` rather than `Linking.openURL`: the latter
 * opens a new tab/window and would strand the user on the screen they were meant
 * to leave. On native, `Linking.openURL` is the correct hand-off.
 *
 * Used for the login / backend hand-off redirects (already-enrolled, lockout,
 * existing-account, and the prod "Sign in" link), where the intent is to leave
 * onboarding — not to spawn a second tab beside it.
 */
export function redirectToUrl(url: string): void {
  if (!url) return;
  if (Platform.OS === 'web') {
    window.location.assign(url);
  } else {
    void Linking.openURL(url);
  }
}
